import { Injectable } from "@angular/core";
import { CanActivate/*, Router*/ } from "@angular/router";
import { Observable } from "rxjs";
import { AppData, IdentityService } from "../shared/bundles/services.bundle";

@Injectable()
export class MaintenanceGuard implements CanActivate {
    constructor(
        private readonly identityService: IdentityService,
        private readonly appData: AppData) { }

    canActivate(): Observable<boolean> | Promise<boolean> | boolean {
        this.identityService.signOut().subscribe(() => {
            this.appData.setAccount(null);
        }, () => {
        });
        return true;
    }
}